import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { toggleEnabledStateForAutomationByIdAction, updateAllAutomationAction, updateAutomationByIdAction, createAutomationForSourceAction } from '../actions';
import { createAutomationForSource, toggleEnabledStateForAutomationById, updateAllAutomations, updateAutomationById } from '../slices';
export function* updateAllAutomationsSaga(action) {
    try {
        yield put(updateAllAutomations({
            automations: action.payload.automations
        }));
    } catch (error) {
        logger.error('Error in updating all automations saga,', {
            error
        });
    }
}
export function* watchUpdateAllAutomationsSaga() {
    yield takeLatest(updateAllAutomationAction.type, updateAllAutomationsSaga);
}
export function* updateAutomationByIdSaga(action) {
    try {
        yield put(updateAutomationById({
            ...action.payload
        }));
    } catch (error) {
        logger.error('Error in updating automations by id saga,', {
            error
        });
    }
}
export function* watchUpdateAutomationByIdSaga() {
    yield takeLatest(updateAutomationByIdAction.type, updateAutomationByIdSaga);
}
export function* toggleEnabledStateForAutomationByIdSaga(action) {
    try {
        yield put(toggleEnabledStateForAutomationById({
            ...action.payload
        }));
    } catch (error) {
        logger.error('Error in toggling enabled for automations by id saga,', {
            error
        });
    }
}
export function* watchToggleEnabledStateForAutomationById() {
    yield takeLatest(toggleEnabledStateForAutomationByIdAction.type, toggleEnabledStateForAutomationByIdSaga);
}
function* createAutomationForSourceSaga(action) {
    try {
        yield put(createAutomationForSource(action.payload));
    } catch (error) {
        logger.error(`Error in creating automation for source ${action.payload.source} of id ${action.payload.sourceId}`, {
            error
        });
    }
}
export function* watchCreateAutomationForSourceSaga() {
    yield takeLatest(createAutomationForSourceAction.type, createAutomationForSourceSaga);
}
export function* watchAllAutomationsSaga() {
    yield all([
        fork(watchUpdateAutomationByIdSaga),
        fork(watchUpdateAllAutomationsSaga),
        fork(watchToggleEnabledStateForAutomationById),
        fork(watchCreateAutomationForSourceSaga)
    ]);
}
